<template>
  <component :is="layout">
    <router-view :key="$route.fullPath"></router-view>
  </component>
</template>

<script>

import axios from 'axios'
import ApiError from './errors.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters('user', {
      logged: 'isLoggedIn'
    }),

    layout () {
      return (this.$route.meta.layout || 'default') + '-layout'
    }
  },
  watch: {
    logged: {
      handler: 'showLoaderApplication',
      immediate: true
    }
  },
  methods: {
    ...mapActions('user', ['initApplication']),

    showLoaderApplication () {
      if (this.logged) {
        if (this.$route.params.site) {
          axios.defaults.headers.common['X-Instance'] = this.$route.params.site
        }

        this.initApplication()
          .then(() => {
            if (this.$route.path === '/' || this.$route.path === '/signin' || this.$route.path === '/activation') {
              this.$router.push({name: 'WorkspaceList'})
            }
          }).catch((e) => {
            return ApiError(e, this)
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Google+Sans');
@import './assets/css/tailwind.css';
@import './assets/scss/global.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue